
import React, { Suspense } from 'react';
import Homepage from '../pages/Homepage/homepage';
import WarrantyForm from '../pages/WarrantyForm/warrantyForm';
import EventCustomer from '../pages/EventCustomer/eventCustomer';
import UnsubscriberPage from '../pages/unsubscribePage/unsubscribePage';
import WarrantyPeriod from '../pages/WarrantyPeriod/warrantyPeriod';
import CustomForm from '../pages/CustomFormPage/customForm';

const authorRouter = [
  {
    path: '/',
    element: <Homepage />,
    auth: true,
  },
  {
    path: '/warranty/:merchant_code/form',
    element: <WarrantyForm />,
    auth: true,
  },
  {
    path: '/check_period/warranty/:merchant_code',
    element: <WarrantyPeriod />,
    auth: true,
  },
  {
    path: '/event/:merchant_code/customer',
    element: <EventCustomer />,
    auth: true,
  },
  {
    path: '/unsubscribe/:merchant_code/resolve',
    element: <UnsubscriberPage />,
    auth: true,
  },
  {
    path: '/custom-form/:form_type/:merchant_code/view',
    element: <CustomForm />,
    auth: true,
  }
]

export { authorRouter }